import { EyeOutlined } from '@ant-design/icons';
import { Access } from '@prisma/client';
import { App, Typography } from 'antd';

import { SourceAccessItem } from '@app/domain-access-interfaces';
import { Tables } from '@app/web-components';

export const useAccessSelectTable = <T extends SourceAccessItem | Access>() => {
  const { modal } = App.useApp();

  const getProps = (
    props?: Omit<Tables.SelectTableProps<T, SourceAccessItem | Access>, 'rowKey'>,
  ): Tables.SelectTableProps<T, SourceAccessItem | Access> => {
    const actions: Tables.ActionMenuProps<T> = {
      items: [
        {
          key: 'details',
          label: 'Details',
          icon: <EyeOutlined />,
        },
        ...(props?.actions?.items ?? []),
      ],
      onClick: (e, record) => {
        if (e.key === 'details') {
          modal.info({
            title: 'Access Detail',
            centered: true,
            width: 900,
            content: (
              <Typography.Text style={{ height: 500, overflow: 'auto' }}>
                <pre style={{ border: 0, margin: 0, height: 500, overflow: 'auto' }}>
                  {JSON.stringify(record, undefined, 2)}
                </pre>
              </Typography.Text>
            ),
          });
        } else {
          props?.actions?.onClick && props?.actions.onClick(e, record);
        }
      },
    };

    return {
      ...props,
      actions,
      rowKey: (record) => `${record.externalId}_${record.accessSource}`,
    };
  };

  return { getProps };
};
